const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

function buildUrl(endpoint, queryParameters = {}) {
  const url = new URL(endpoint, BASE_URL);

  Object.entries(queryParameters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function fetchJSON(endpoint, queryParameters) {
  const res = await fetch(buildUrl(endpoint, queryParameters));
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

const api = {
  getLanguages: () => fetchJSON('/api/languages'),
  getAbout: (language) => fetchJSON('/api/about', { lang: language }),
  getExperience: (language) => fetchJSON('/api/experience', { lang: language }),
  getProjects: (language) => fetchJSON('/api/projects', { lang: language }),
  getProject: (id, language) => fetchJSON(`/api/projects/${id}`, { lang: language }),
  sendContact: (data) =>
    fetch(buildUrl('/api/contact'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) throw new Error(`Contact error: ${res.status}`);
      return res.json();
    }),
};

export default api;
